<template>
    <CardContentPanel icon="star" v-bind="{action, index}">
        <template #title="{freelancerName}">
            {{ $t('projectclient.projectview.activity.pending.actions.LEAVE_APPRAISAL.title', {0: freelancerName}) }}
        </template>
        <template #body="{freelancerName}">
            {{ $t('projectclient.projectview.activity.pending.actions.LEAVE_APPRAISAL.description', {0: freelancerName}) }}
        </template>
        <template #actions>
            <VJoyButton
                :loading="isAppraisalRedirection"
                :disabled="!isAllowedToLeaveAnAppraisal"
                :title="$t('projectclient.projectview.activity.pending.actions.LEAVE_APPRAISAL.action.disabled.title')"
                variant="main"
                size="small"
                data-testid="pending-action-card-cta-primary"
                @click="leaveAppraisal"
            >
                {{ $t('projectclient.projectview.activity.pending.actions.LEAVE_APPRAISAL.action.primary') }}
            </VJoyButton>
        </template>
    </CardContentPanel>
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {navigateTo} from '@typed-router';
    import {storeToRefs} from 'pinia';
    import {VJoyButton} from '@maltjoy/core-vue';
    import CardContentPanel from '../CardContentPanel.vue';
    import {useProjectInformationStore, useUserStore} from '@/common/stores';
    import type {ActivityPendingActionByType} from '@/features/project-view';

    defineProps<{
        action: ActivityPendingActionByType<'LEAVE_APPRAISAL'>;
        index: number;
    }>();

    const projectInformationStore = useProjectInformationStore();

    const userStore = useUserStore();
    const {roles} = storeToRefs(userStore);
    const {projectInformation, isAppraisalRedirection} = storeToRefs(projectInformationStore);

    const isParticipant = computed(() => projectInformation.value?.participant);
    const hasAuthorityToLeaveAnAppraisal = computed(() => roles.value.includes('ROLE_ADMIN_WRITE_APPRAISAL'));

    const isAllowedToLeaveAnAppraisal = computed(() => isParticipant.value || (!isParticipant.value && hasAuthorityToLeaveAnAppraisal.value));

    function leaveAppraisal() {
        navigateTo(`/appraisal/freelancer-by-client/${projectInformation.value.projectId}?origin=project-view`, {external: true});
    }
</script>
